// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-404__error {
    padding: 20px;
    border: thin solid var(--main-border-color);
    border-radius: 10px;
    background-color: white;
    max-width: 600px;
    margin: 0 auto;
    font-size: 16px;
}
.error-404__error h1 {
    font-size: 2em;
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./client/components/errors/Error404.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,2CAA2C;IAC3C,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;AACA;IACI,cAAc;IACd,kBAAkB;AACtB","sourcesContent":[".error-404__error {\n    padding: 20px;\n    border: thin solid var(--main-border-color);\n    border-radius: 10px;\n    background-color: white;\n    max-width: 600px;\n    margin: 0 auto;\n    font-size: 16px;\n}\n.error-404__error h1 {\n    font-size: 2em;\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
